module.exports = __webpack_public_path__ + "img/appBarMultihogar.0729cfa8.png";